import { createBrowserRouter } from 'react-router-dom'
import BaseLayout from '../pages/layouts/BaseLayout'
//import LoraHistoryScreen from '../components/LoraHistory/LoraHistoryScreen'
//import TrainLoraScreen from '../components/GenerateImg/TrainLoraScreen'
import Img2ImgScreen from '../components/GenerateImg/Img2ImgScreen'
import RenderHistoryScreen from '../components/RenderHistory/RenderHistoryScreen'

const router = createBrowserRouter([
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Img2ImgScreen />
      },
      //{
      //  path: 'train-lora',
      //  element: <TrainLoraScreen />
      //},
      {
        path: 'img2img',
        element: <Img2ImgScreen />
      },
      //{
      //  path: 'lora-history',
      //  element: <LoraHistoryScreen />
      //},
      {
        path: 'render-history',
        element: <RenderHistoryScreen />
      }
    ]
  }
])

export default router
